import React from "react";
import contextProvider from "app/contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";

import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
import ReactOActionBar from "app/_L1_components/Elements/ReactOActionBar";
import ReactOForm from "app/_L1_components/Elements/ReactOForm";
import ReactOFormInput from "app/_L1_components/Elements/ReactOFormInput";

class Account extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
    };
    super(props, initState);
  }

  changePassword(data, cb) {
    //		console.log("DEBUG :: Account _ changePassword");
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("change_pass", {
          data: data,
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
          ___onError: (error, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                if (cb) {
                  cb(
                    "KO",
                    error == "ACCOUNT_PWD_CHANGE_CONFIRMATION"
                      ? "Please confirm new password"
                      : ""
                  );
                }
              }
            );
          },
        });
      }
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    //		console.log("DEBUG :: Account _ onComponentDidMount");
    if (this.getAppContext().authHandler.getAccountData().alias == "yes") {
      this.getAppContext().redirectTo("/web");
    }
    this.apiStore = this.getAppContext().getApiStoreService();
    this._pwd_change_form.init();
    //	this.loadProbeUsers();
  }

  onComponentWillUnmount() {}

  onRender() {
    return (
      <Section designType="narrow" className="mt-3">
        <_LoadingWrapper loadingPlug={this.state.loading}>
          <div className="d-flex py-4">
            <div className="flex-shrink-1 mr-3" style={{ fontSize: "40px" }}>
              <span className="icon-user" />
            </div>
            <div className="flex-grow-1">
              <h2>{this.getAppContext().authHandler.getAccountData().user}</h2>
              <small className="text-muted">
                ({this.getAppContext().authHandler.getAccountData().type})
              </small>
            </div>
          </div>

          <Panel
            rounded
            className="mb-4"
            header="Change password"
            style={{
              minHeight: "50px",
            }}
          >
            <ReactOForm
              onSubmit={this.changePassword.bind(this)}
              onControllerReady={(form_controller) => {
                this._pwd_change_form = form_controller;
              }}
              onFormDidSubmit={(is_dirty) => {
                if (!is_dirty) {
                  this._pwd_change_form.reset();
                  this.getAppContext().alert({
                    type: "message",
                    title: "Password change",
                    message: "Password changed successfully",
                  });
                }
              }}
            >
              <Row className="mb-3">
                <Col xs={4}>
                  <ReactOFormInput
                    type="password"
                    data_key="curr_pwd"
                    label="Current password"
                    placeholder="Type current password"
                    required
                    autofocus
                    remote_validators={[
                      {
                        func: (value) => {
                          return value == "NOT_VALID" ? false : true;
                        },
                        invalid_text: "Wrong password",
                      },
                    ]}
                  />
                </Col>
                <Col xs={4}>
                  <ReactOFormInput
                    type="password"
                    data_key="new_pwd"
                    label="New password"
                    placeholder="Type new password"
                    required
                    remote_validators={[
                      {
                        func: (value) => {
                          if (/NOT_VALID|INSECURE/.test(value)) {
                            this._pwd_change_form.setEntry("new_pwd", false);
                            this._pwd_change_form.setEntry("confirm_pwd", false);
                          }
                          return value == "NOT_VALID" ? false : true;
                        },
                        invalid_text: "Password not acceptable. Choose another password",
                      },
                      {
                        func: (value) => {
                          return value == "INSECURE" ? false : true;
                        },
                        invalid_text: "Insecure password. Choose another password",
                      },
                    ]}
                  />
                </Col>
                <Col xs={4}>
                  <ReactOFormInput
                    type="password"
                    data_key="confirm_pwd"
                    label="Confirm new password"
                    placeholder="Confirm new password"
                    required
                    remote_validators={[
                      {
                        func: (value) => {
                          return value == "NOT_VALID" ? false : true;
                        },
                        invalid_text: "Confirm new password",
                      },
                    ]}
                  />
                </Col>
              </Row>
              {/*<Row>
								<Col xs={12}>
									<ReactOFormInput type="error_display"/>
								</Col>
							</Row>*/}
              <Row>
                <Col xs={12}>
                  <ReactOActionBar align="right" padding="0">
                    <ReactOFormInput
                      type="submit"
                      value="Save"
                      color="primary"
                      icon="save"
                    >
                      Change
                    </ReactOFormInput>
                  </ReactOActionBar>
                </Col>
              </Row>
            </ReactOForm>
          </Panel>
        </_LoadingWrapper>
      </Section>
    );
  }
}

export default contextProvider(
  withRouter(Account),
  //	withDefinedContext(Account, 'Account', context_exposed_methods),
  {
    define: null,
  }
);
